









import { Vue, Component } from 'vue-property-decorator';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import LabelTag from './LabelTag.vue';
@Component({
  components: { LabelTag }
})
export default class LeftChart1 extends Vue {
  dashSrv = new DashboardServices();

  option: any = {
    legend: {
      data: [
        {
          name: '日增',
          color: '#00baff'
        },
        {
          name: '一级',
          color: '#ff5ca9'
        },
        {
          name: '二级',
          color: '#3de7c9'
        },
        {
          name: '三级',
          color: '#f5d94e'
        }
      ],
      textStyle: {
        fill: '#fff'
      }
    },
    xAxis: {
      data: [],
      axisLine: {
        style: {
          stroke: '#999'
        }
      },
      axisLabel: {
        style: {
          fill: '#999'
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      data: 'value',
      splitLine: {
        show: false
      },
      axisLine: {
        style: {
          stroke: '#999'
        }
      },
      axisLabel: {
        style: {
          fill: '#999'
        }
      },
      axisTick: {
        show: false
      },
      min: 0
    },
    series: [
      {
        name: '日增',
        data: [],
        type: 'bar',
        barStyle: {
          fill: 'rgba(0, 186, 255, 0.4)'
        }
      },
      {
        name: '一级',
        data: [],
        type: 'line',
        lineStyle: {
          stroke: '#ff5ca9'
        },
        linePoint: {
          radius: 4,
          style: {
            fill: '#ff5ca9',
            stroke: 'transparent'
          }
        }
      },
      {
        data: [],
        type: 'line',
        name: '二级',
        lineArea: {
          show: true,
          gradient: ['rgba(245, 217, 79, 0.8)', 'rgba(245, 217, 79, 0.2)']
        },
        lineStyle: {
          stroke: '#f5d94e'
        },
        linePoint: {
          radius: 4,
          style: {
            fill: '#f5d94e',
            stroke: 'transparent'
          }
        }
      },
      {
        name: '三级',
        data: [],
        type: 'line',
        smooth: true,
        lineArea: {
          show: true,
          gradient: ['rgba(55, 162, 218, 0.6)', 'rgba(55, 162, 218, 0)']
        },
        lineStyle: {
          lineDash: [5, 5]
        },
        linePoint: {
          radius: 4,
          style: {
            fill: '#00db95'
          }
        }
      }
    ]
  };

  created() {
    let [startTime, endTime] = getRange('total');
    this.getTrend({ startTime, endTime });
  }

  async getTrend(params?: any) {
    let total = await this.dashSrv.getTrend(params);
    let trend1 = await this.dashSrv.getTrend({ ...params, alertLevel: 1 });
    let trend2 = await this.dashSrv.getTrend({ ...params, alertLevel: 2 });
    let trend3 = await this.dashSrv.getTrend({ ...params, alertLevel: 3 });
    let xAxisData: any = [];
    let totalData: any = [];
    let trend1Data: any = [];
    let trend2Data: any = [];
    let trend3Data: any = [];
    total.forEach((v: any) => {
      xAxisData.push(v.alertDate);
      totalData.push(v.value);
      let t1 = trend1.find((t: any) => t.alertDate === v.alertDate);
      trend1Data.push(t1 ? t1.value : 0);
      let t2 = trend2.find((t: any) => t.alertDate === v.alertDate);
      trend2Data.push(t2 ? t2.value : 0);
      let t3 = trend3.find((t: any) => t.alertDate === v.alertDate);
      trend3Data.push(t3 ? t3.value : 0);
    });
    this.option.series[0].data = totalData;
    this.option.series[1].data = trend1Data;
    this.option.series[2].data = trend2Data;
    this.option.series[3].data = trend3Data;
    this.option.xAxis.data = xAxisData;
  }
}
